import { action, makeObservable, observable } from 'mobx';
import { useEffect } from 'react';
import { API } from '~/api';
import { FragranceId } from '~/api/api.declaration';
import { ApiService } from '~/service/service.api';
import { UserId } from '~/shared/dto/id';
import { ModerationStatus } from '~/shared/dto/model.enums';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';

@Model()
export class FragranceReviewModel {
	@observable offset = 0;
	@observable data = [] as API.FragranceReview[];
	readonly limit = 20;
	readonly async = new Async();
	private fragranceId?: FragranceId;

	constructor(private api: ApiService) {
		makeObservable(this);
	}

	use = (fragranceId: FragranceId) => {
		this.fragranceId = fragranceId;
		useEffect(() => {
			this.fetchNextPage();
		}, []);
	};

	fetchNextPage = () => {
		this.async.call(async () => {
			if (this.fragranceId) {
				const { data } = await this.api.fragranceGetReviews(this.fragranceId, {
					limit: this.limit,
					offset: this.offset,
				});
				return () => {
					this.data = [...this.data, ...data.items];
					this.offset += this.limit;
				};
			}
		});
	};

	@action.bound reload() {
		this.offset = 0;
		this.fetchNextPage();
	}

	hideReview = (userId: UserId) => {
		this.changeReviewStatus(userId, 'HIDDEN');
	};

	approveReview = (userId: UserId) => {
		this.changeReviewStatus(userId, 'APPROVED');
	};

	private changeReviewStatus(userId: UserId, status: ModerationStatus) {
		this.async.call(async () => {
			if (this.fragranceId && userId) {
				await this.api.fragranceChangeReviewStatus(this.fragranceId, userId, { status });
				return () => {
					const review = this.data.find(r => r.userId === userId);
					if (review) {
						review.moderation = status;
					}
				};
			}
		});
	}
}
